export const appGroupIdCanvasWorkflowIdStepStepIdMessages =
  "/:app_group_id/canvas/:workflow_id/step/:step_id/messages";
